/** @jsx jsx */
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'

const AboutIconListSection = ({ cards, cta, title }) => {
  return (
    <Box bg="backgroundBright" pt={[6, 7, 9]} pb={[7, 8, 10]}>
      <Container sx={{ textAlign: 'center' }}>
        <Heading as="h2" variant="title2" mb={[4, 5]}>
          {title}
        </Heading>
        <Grid columns={[1, 3]}>
          {cards.map((card, index) => {
            const titlePieces = card.title.split('_')

            return (
              <Box key={`card-${index}`}>
                <Box mb={3}>
                  <img
                    src={`/images/backgrounds/about-maker-${index + 1}.svg`}
                    alt=""
                    aria-hidden="true"
                  />
                </Box>
                <Heading as="h3" variant="title3">
                  <Box as="span">{titlePieces[0]}</Box>
                  {typeof titlePieces[1] !== 'undefined' && (
                    <Box
                      as="span"
                      sx={{
                        display: 'inline-block',
                        position: 'relative',
                        zIndex: '1',
                        '&:after': {
                          backgroundColor: '#FFD5B2',
                          borderRadius: '16px',
                          bottom: '0',
                          content: '""',
                          display: 'block',
                          height: '14px',
                          left: '-3px',
                          position: 'absolute',
                          right: '-3px',
                          zIndex: '-1',
                        },
                      }}
                    >
                      {titlePieces[1]}
                    </Box>
                  )}
                  {typeof titlePieces[2] !== 'undefined' && (
                    <Box as="span">{titlePieces[2]}</Box>
                  )}
                </Heading>
                {card.description && (
                  <Box
                    mt={2}
                    variant="text.body2"
                    dangerouslySetInnerHTML={{
                      __html: card.description.childMarkdownRemark.html,
                    }}
                    sx={{ p: { m: 0 } }}
                  />
                )}
              </Box>
            )
          })}
        </Grid>
        {cta && <Box mt={4}>{cta}</Box>}
      </Container>
    </Box>
  )
}

export default AboutIconListSection
